import React from "react";

/**
 * Logo oficial RotulaciónDNF.
 *
 * @param {number} size - alto/ancho en px (mantiene aspecto)
 * @param {"dark"|"light"} variant
 *   - "dark"  (default): texto "ROTULACIÓN" en BLANCO. Pensado para fondos oscuros (sidebar, header app).
 *   - "light": texto "ROTULACIÓN" en NEGRO. Pensado para fondos claros (portal cliente, PDFs, emails).
 */
export default function DnfLogo({ size = 40, variant = "dark", className = "" }) {
  const src = variant === "light"
    ? "/brand/logo-rotulaciondnf-light.png"
    : "/brand/logo-rotulaciondnf.png";
  return (
    <img
      src={src}
      alt="RotulaciónDNF"
      width={size}
      height={size}
      className={className}
      style={{ objectFit: "contain" }}
    />
  );
}
